module.exports = __webpack_public_path__ + "static/img/solutionPic3.706bbd8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionPic3.png
// module id = f5bG
// module chunks = 1